module.exports = __webpack_public_path__ + "media/images/icons/material/history-black-124dae174eafcd202bcd3c3d3c6f90dd.svg";